import styles from "./Rules.module.css";
import CircleCheck from "../../assets/CheckCircle.svg";
import User from "../../assets/User.svg";
import CircleCross from "../../assets/XCircle.svg";
import cx from "classnames";
import React from "react";

const Check = <CircleCheck className="text-coinage-teal" width="32" />;
const Cross = <CircleCross className="text-coinage-orange" width="32" />;
const Divider = (
  <div
    className={`${styles.fw} border-t-[1px] border-color-coinage-stroke my-2 tab:my-4 `}
  />
);

const textContainerStyles = cx(styles.fwMob, "text-center tab:text-left");

const countContainerClassName = "flex gap-4 items-center";

const Dots = ({ count }: { count: 1 | 2 | 3 }) => {
  const dots = [...Array(count * 2).keys()];
  const gridClass = cx("grid gap-[8px] grid-rows-2", {
    "grid-cols-2": count === 2,
    "grid-cols-1": count === 1,
    "grid-cols-3": count === 3
  });

  return (
    <div className={gridClass}>
      {dots.map(dot => (
        <svg
          className="w-[5px]"
          key={dot}
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg">
          <circle cx="50" cy="50" r="50" />
        </svg>
      ))}
    </div>
  );
};

export const RulesTable = () => {
  return (
    <section
      className={`${styles.grid} body2 text-coinage-black my-8 max-w-lg tab:max-w-full`}>
      <div className="hidden tab:block" />

      <span className="flex gap-2 mono1 mb-2 tab:mb-6">
        <User className="text-coinage-blue" width="32" /> Player 1
      </span>

      <span className="flex gap-2 mono1 mb-2 tab:mb-6">
        <User className="text-coinage-blue" width="32" /> Player 2
      </span>

      <p className={textContainerStyles}>
        If both players <b className="text-coinage-teal">trust</b>, they’ll each
        receive 4 invitations.
      </p>

      <div className={countContainerClassName}>
        {Check} <Dots count={2} />
      </div>
      <div className={countContainerClassName}>
        {Check} <Dots count={2} />
      </div>
      {Divider}

      <p className={textContainerStyles}>
        If one player <b className="text-coinage-orange">distrusts</b>, while
        the other <b className="text-coinage-teal">trusts</b>, the distrusting
        player will receive 6 invitations and the trusting player will receive 2
        invitations.
      </p>
      <div className={countContainerClassName}>
        {Cross} <Dots count={3} />
      </div>
      <div className={countContainerClassName}>
        {Check} <Dots count={1} />
      </div>

      {Divider}

      <p className={textContainerStyles}>
        If both players <b className="text-coinage-orange">distrust</b>, they’ll
        each receive 0 invitations.
      </p>

      <div>{Cross}</div>
      <div>{Cross}</div>
    </section>
  );
};
